import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  Grid,
  makeStyles,
  IconButton,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Typography,
  TextField as MaterialTexfield,
  FormControlLabel,
  useTheme,
  FormHelperText,
  Input,
  Chip,
} from "@material-ui/core";
import { useForm } from "react-hook-form";
import CloseIcon from "@material-ui/icons/Close";
import { doctorServices, productsServices } from "../services";
import { AuthContext } from "../context";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField, ModalBase } from "./";
import { laboratoryServices } from "../services";

import RichTextEditor from "react-rte";
import SyncOutlinedIcon from "@material-ui/icons/SyncOutlined";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function AddProduct(props) {
  const theme = useTheme();

  // Estados
  const { authState } = useContext(AuthContext);
  const isMasterAdmin = authState.user.role._id === "5fdb9e3db3bfce86908e440f";
  const isAdmin = authState.user.role.name === "LABORATORY_ADMIN";
  const [indicationsState, setIndicationState] = useState("");
  const [contraIndi, setContraIndi] = useState("");
  const [fileUpload, setFileUpload] = useState(null);
  const [state, setState] = useState("");
  const [previewImage, setPreviewImage] = useState(null);
  const [specialties, setSpecialties] = useState(
    isMasterAdmin || isAdmin ? [] : authState.user.laboratory.specialties
  );
  const [previewDoc, setPreviewDoc] = useState([]);
  // const [labId, setLabId] = useState("");
  const [richTextPrograms, setRichTextPrograms] = useState("");
  const [loading, setLoading] = useState(false);
  // const { specialtiesList, childLaboratories } = props;
  const classes = useStyles();
  const [selectedSpecialties, setSelectedSpecialties] = useState([]);
  const [productStatuses, setProductStatuses] = useState([]);
  const [laboratories, setLaboratories] = useState([]);
  const [selectedLab, setSelectedLab] = useState(null);
  const [selectedChildLabId, setSelectedChildLabId] = useState(null);
  const [loadingChildLab, setLoadingChildLab] = useState(false);
  const [childLaboratories, setChildLaboratories] = useState(
    isMasterAdmin ? [] : isAdmin ? props.childLaboratories : null
  );
  const [isAvailableToCreate, setIsAvailableToCreate] = useState(
    !isMasterAdmin
  );

  // Hook useForm
  const {
    register,
    handleSubmit,
    setValue,
    formState: { isSubmitted, errors },
  } = useForm();

  useEffect(() => {
    const getAllProductStatus = async () => {
      try {
        const response = await productsServices.getAllProductStatus({
          token: authState.token,
        });
        setProductStatuses(response.data);
      } catch (error) {
        console.error("Error al obtener los estados de las ordenes:", error);
      }
    };

    getAllProductStatus();
  }, []);

  useEffect(() => {
    // Get all Labs
    async function init() {
      try {
        const { status, response } = await laboratoryServices.getLaboratories({
          token: authState.token,
        });
        if (status === 200) {
          setLaboratories(response.laboratories);
          // console.log("labs", response.laboratories);
        }
      } catch (error) {
        console.error("Error al obtener los laboratorios:", error);
      }
    }
    if (isMasterAdmin) init();
  }, []);

  useEffect(() => {
    async function getChildLaboratories() {
      // Get Children by lab
      try {
        setLoadingChildLab(true);
        setSelectedChildLabId(null);
        const { status, response } =
          await laboratoryServices.getChildLaboratories({
            laboratoryId: selectedLab,
            token: authState.token,
            text: "",
          });
        if (status === 200) {
          setChildLaboratories(response.laboratories);
        }
      } catch (error) {
        console.error("Error durante la carga de child laboratories:", error);
      } finally {
        setLoadingChildLab(false);
      }
    }
    if (isMasterAdmin && selectedLab) getChildLaboratories();
  }, [selectedLab]);

  useEffect(() => {
    if (selectedChildLabId && (isMasterAdmin || isAdmin)) {
      const selectedChildLaboratory = childLaboratories.find(
        ({ _id }) => _id === selectedChildLabId
      );
      setSpecialties(() => selectedChildLaboratory.specialties);
      setSelectedSpecialties([]);
    }
  }, [selectedChildLabId]);
  useEffect(() => {
    if (isMasterAdmin) {
      if (selectedLab && selectedChildLabId) {
        setIsAvailableToCreate(() => true);
      } else setIsAvailableToCreate(() => false);
    }
  }, [selectedChildLabId, selectedLab]);
  // Manejador de cambio de archivo
  const handleChange = async (e) => {
    setPreviewImage(URL.createObjectURL(e.target.files[0]));
    setFileUpload(e.target.files[0]);
  };

  // Manejador de cambio de estudios clínicos
  const handleChangeStudies = async (e) => {
    setPreviewDoc([...e.target.files]);
  };

  // Eliminar estudio clínico
  const onDeleteClinicalStudy = (name) => {
    setPreviewDoc((prevDocs) => prevDocs.filter((doc) => doc.name !== name));
  };
  // Función para guardar el producto
  const saveProduct = async (dataToInsert) => {
    // console.log("Esto es el dataToInsert: ", dataToInsert);
    if (!selectedChildLabId && isAdmin) return;
    if (!state || !selectedSpecialties.length) return;
    const formData = new FormData();
    formData.append("name", dataToInsert.name);
    formData.append("molecule", dataToInsert.molecule);
    formData.append("bula", dataToInsert.bula || "");
    formData.append("indications", indicationsState);
    formData.append("presentation", dataToInsert.presentation);
    formData.append("concentration", dataToInsert.concentration);
    formData.append("isp", dataToInsert.isp);
    formData.append("price", dataToInsert.price || "0");
    formData.append(
      "laboratoryId",
      isMasterAdmin || isAdmin
        ? selectedChildLabId
        : authState.user.laboratory._id
    );
    formData.append("logo", fileUpload);
    formData.append("contraIndications", contraIndi);
    formData.append("specialties", JSON.stringify(selectedSpecialties));
    previewDoc.forEach((doc) => formData.append("clinicalStudies", doc));
    formData.append(
      "richTextPrograms",
      JSON.stringify({ text: dataToInsert.programs })
    );
    formData.append("status", state);
    // const data = Object.fromEntries(formData.entries());
    // console.log(data);
    try {
      setLoading(true);
      const { status, response } = await productsServices.addProduct({
        formData,
        token: authState.token,
      });

      switch (status) {
        case 201:
          props.reload();
          props.toast(response.message, true);
          props.close();
          break;
        case 200:
          props.toast(response.message, true);
          break;
        default:
          break;
      }

      if (response.error) {
        props.toast(response.error.message, true);
      }

      props?.refetch && props?.refetch();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  // Estados y funciones para el editor de texto enriquecido (Rich Text Editor)
  const [richTextP, setRichTextP] = useState(RichTextEditor.createEmptyValue());
  const [openRichTextP, setOpenRichTextP] = useState(false);
  const [richTextC, setRichTextC] = useState(RichTextEditor.createEmptyValue());
  const [openRichTextC, setOpenRichTextC] = useState(false);

  return (
    <ModalBase open={props.open} close={props.close} title="Agregar producto">
      <form className={classes.form} onSubmit={handleSubmit(saveProduct)}>
        <Grid container spacing={2}>
          {isMasterAdmin && (
            <>
              <Grid item lg={6} xs={12} sm={12}>
                <FormControl
                  variant="outlined"
                  className={`${classes.formControl}  ${classes.shrinkLabel}`}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    Laboratorio
                  </InputLabel>
                  <Select
                    labelId="demo-mutiple-name-label"
                    id="demo-mutiple-name"
                    label="Laboratorio"
                    value={selectedLab}
                    onChange={(e) => setSelectedLab(e.target.value)}
                    MenuProps={MenuProps}
                    className={classes.select}
                  >
                    {laboratories.map((element, index) => (
                      <MenuItem key={index} value={element._id}>
                        {element.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText
                    id="helper text for laboratory select"
                    error={!selectedLab}
                  >
                    {!selectedLab ? "Seleccione un laboratorio" : ""}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item lg={6} xs={12} sm={12}>
                <FormControl
                  variant="outlined"
                  className={`${classes.formControl}  ${classes.shrinkLabel}`}
                  style={{ position: "relative" }}
                  disabled={!selectedLab || loadingChildLab}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    Unidad de negocio
                  </InputLabel>
                  <Select
                    labelId="demo-mutiple-name-label"
                    id="demo-mutiple-name"
                    label="Unidad de negocio"
                    value={selectedChildLabId}
                    onChange={(e) => setSelectedChildLabId(e.target.value)}
                    MenuProps={MenuProps}
                    className={classes.select}
                  >
                    {childLaboratories.map((element, index) => (
                      <MenuItem key={index} value={element._id}>
                        {element.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {loadingChildLab && (
                    <SyncOutlinedIcon
                      color="action"
                      style={{
                        position: "absolute",
                        top: "20%",
                        right: "5%",
                        backgroundColor: "#fff",
                      }}
                      className={classes.loadingIcon}
                    />
                  )}
                  <FormHelperText
                    id="helper text for child laboratory  select"
                    error={selectedLab && !isAvailableToCreate}
                  >
                    {selectedLab && !isAvailableToCreate
                      ? "Seleccione una unidad de negocio"
                      : ""}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </>
          )}
          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="name"
              label="Nombre"
              placeholder="Nombre"
              name="name"
              autoComplete="name"
              size="small"
              inputRef={register({
                required: "Nombre requerido",
              })}
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.name ? true : false}
              helperText={errors.name ? errors.name.message : ""}
              disabled={!isAvailableToCreate}
            />
          </Grid>

          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="molecule"
              label="Molécula"
              name="molecule"
              placeholder="Molécula"
              autoComplete="molecule"
              size="small"
              inputRef={register({
                required: "Molécula requerida",
              })}
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.molecule ? true : false}
              helperText={errors.molecule ? errors.molecule.message : ""}
              disabled={!isAvailableToCreate}
            />
          </Grid>
          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="presentation"
              label="Presentación"
              name="presentation"
              placeholder="Presentación"
              autoComplete="presentation"
              size="small"
              inputRef={register({
                required: "Presentación requerida",
              })}
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.presentation ? true : false}
              helperText={
                errors.presentation ? errors.presentation.message : ""
              }
              disabled={!isAvailableToCreate}
            />
          </Grid>

          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="concentration"
              label="Concentración"
              name="concentration"
              placeholder="Concentración"
              autoComplete="concentration"
              size="small"
              inputRef={register({
                required: "Concentración requerida",
              })}
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.concentration ? true : false}
              helperText={
                errors.concentration ? errors.concentration.message : ""
              }
              disabled={!isAvailableToCreate}
            />
          </Grid>

          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="isp"
              label="ISP"
              name="isp"
              placeholder="ISP"
              autoComplete="isp"
              size="small"
              inputRef={register({
                required: "ISP requerido",
              })}
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.isp ? true : false}
              helperText={errors.isp ? errors.isp.message : ""}
              disabled={!isAvailableToCreate}
            />
          </Grid>
          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="price"
              label="Precio referencial"
              name="price"
              placeholder="Precio referencial"
              type="string"
              autoComplete="price"
              size="small"
              inputRef={register()}
              InputLabelProps={{
                shrink: true,
              }}
              disabled={!isAvailableToCreate}
            />
          </Grid>

          {isAdmin && (
            <Grid item lg={12} xs={12} sm={12}>
              <FormControl
                variant="outlined"
                className={`${classes.formControl}  ${classes.shrinkLabel}`}
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  Unidad de negocio
                </InputLabel>
                <Select
                  labelId="demo-mutiple-name-label"
                  id="demo-mutiple-name"
                  label="Unidad de negocio"
                  value={selectedChildLabId}
                  onChange={(e) => setSelectedChildLabId(e.target.value)}
                  MenuProps={MenuProps}
                  className={classes.select}
                >
                  {childLaboratories.map((element, index) => (
                    <MenuItem key={index} value={element._id}>
                      {element.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  id="admin  child laboratory  select"
                  error={!selectedChildLabId}
                >
                  {!selectedChildLabId && isSubmitted
                    ? "Seleccione una unidad de negocio"
                    : ""}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}
          <Grid item lg={12} xs={12} sm={12}>
            <FormControl
              variant="outlined"
              className={`${classes.formControl}  ${classes.autoComplete} ${classes.shrinkLabel}`}
            >
              {/* <InputLabel id="demo-mutiple-chip-label">
                Especialidades
              </InputLabel>
              <Select
                labelId="demo-mutiple-chip-label"
                id="demo-mutiple-chip"
                multiple
                value={selectedSpecialties}
                onChange={(e) => setSelectedSpecialties(e.target.value)}
                renderValue={(selected) => (
                  <div className={classes.chips}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={
                          specialties.find(({ _id }) => _id === value)?.name
                        }
                        className={classes.chip}
                      />
                    ))}
                  </div>
                )}
                MenuProps={MenuProps}
                className={classes.select}
              >
                {specialties?.map((specialty) => (
                  <MenuItem key={specialty._id} value={specialty._id}>
                    {specialty.name}
                  </MenuItem>
                ))}
              </Select> */}
              <Autocomplete
                disabled={!isAvailableToCreate}
                style={{ borderRadius: 25 }}
                multiple
                id="especialidades"
                options={specialties}
                getOptionLabel={(option) => option.name}
                filterSelectedOptions
                variant="outlined"
                label="Especialidades"
                value={selectedSpecialties}
                getOptionSelected={(option, value) => option._id === value?._id}
                onChange={(event, newValue) => {
                  setSelectedSpecialties(newValue);
                }}
                renderInput={(params) => (
                  <MaterialTexfield
                    {...params}
                    id="especialidades"
                    name="especialidades"
                    placeholder="Especialidades"
                    variant="outlined"
                    label="Especialidades"
                  />
                )}
              />
              <FormHelperText error={!selectedSpecialties.length}>
                {isSubmitted && !selectedSpecialties.length
                  ? "Seleccione al menos una especialidad"
                  : ""}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item lg={12} xs={12} sm={12}>
            <FormControl
              variant="outlined"
              className={`${classes.formControl}  ${classes.shrinkLabel}`}
              disabled={!isAvailableToCreate}
            >
              <InputLabel htmlFor="orders-status-select">
                Estado del producto
              </InputLabel>
              <Select
                value={state}
                onChange={(e) => setState(e.target.value)}
                inputProps={{
                  name: "status",
                  id: "orders-status-select",
                }}
                className={classes.select}
              >
                {productStatuses.map((status) => (
                  <MenuItem key={status._id} value={status._id}>
                    {status.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText error={!state}>
                {isSubmitted && !state ? "Estado requerido" : ""}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item lg={12} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="indications"
              label="Indicaciones"
              name="indications"
              placeholder="Indicaciones"
              multiline
              rows={3}
              autoComplete="indications"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => setIndicationState(e.target.value)}
              disabled={!isAvailableToCreate}
            />
          </Grid>
          <Grid item lg={12} xs={12} sm={12}>
            {/* <TextField
              variant="outlined"
              fullWidth
              id="contraIndications"
              multiline
              rows={3}
              label="Contraindicaciones"
              placeholder="Contraindicaciones"
              name="contraIndications"
              autoComplete="contraIndications"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => setContraIndi(e.target.value)}
            /> */}

            <FormControl
              style={{ display: "flex" }}
              disabled={!isAvailableToCreate}
            >
              <InputLabel
                htmlFor="rich-text"
                style={{ color: theme.palette.primary.main }}
              >
                Contraindicaciones
              </InputLabel>
              {/* 
              <Input
                id="rich-text"
                aria-describedby="helper-rich-text"
                disableUnderline
                name="contraIndications"
                inputComponent={() => (
                  
                )}
              /> */}
              <RichTextEditor
                toolbarConfig={{
                  display: ["LINK_BUTTONS", "INLINE_STYLE_BUTTONS"],
                  INLINE_STYLE_BUTTONS: [
                    {
                      label: "Bold",
                      style: "BOLD",
                      className: "custom-css-class",
                    },
                    { label: "Italic", style: "ITALIC" },
                    { label: "Underline", style: "UNDERLINE" },
                  ],
                }}
                rootStyle={{
                  innerWidth: "100%",
                  outerWidth: "100%",
                  width: "100%",
                  fontFamily: "Arial",
                  margin: "3rem 0 0 0",
                  zIndex: "999",
                  borderRadius: "25px",
                }}
                id="rich-text"
                readOnly={!openRichTextC}
                value={richTextC}
                onChange={(rtext) => {
                  setRichTextC(rtext);
                  setValue("contraIndications", rtext.toString("html"));
                  setContraIndi(rtext.toString("html"));
                }}
              />
              <FormHelperText
                id="my-helper-text"
                error={Boolean(errors.contraIndications)}
                helperText={
                  errors.contraIndications
                    ? errors.contraIndications.message
                    : " "
                }
              />
              <Button
                fullWidth
                component="label"
                color="primary"
                variant="outlined"
                style={{ borderRadius: 25 }}
                disabled={!isAvailableToCreate}
                onClick={() => {
                  setOpenRichTextC(!openRichTextC);
                }}
              >
                {openRichTextC ? "Cerrar Editor" : "Agregar Contraindicaciones"}
              </Button>
            </FormControl>
          </Grid>
          <Grid item lg={12} xs={12} sm={12}>
            <FormControl
              style={{ display: "flex" }}
              disabled={!isAvailableToCreate}
            >
              <InputLabel
                htmlFor="rich-text"
                style={{ color: theme.palette.primary.main }}
              >
                Programas
              </InputLabel>

              {/* <Input
                id="rich-text"
                aria-describedby="helper-rich-text"
                disableUnderline
                name="programs"
                // inputRef={register({
                //                // required: "Programas requerido",
                //              })}
                inputComponent={() => (
                  )}
              /> */}
              <RichTextEditor
                toolbarConfig={{
                  display: ["LINK_BUTTONS", "INLINE_STYLE_BUTTONS"],
                  INLINE_STYLE_BUTTONS: [
                    {
                      label: "Bold",
                      style: "BOLD",
                      className: "custom-css-class",
                    },
                    { label: "Italic", style: "ITALIC" },
                    { label: "Underline", style: "UNDERLINE" },
                  ],
                }}
                rootStyle={{
                  innerWidth: "100%",
                  outerWidth: "100%",
                  width: "100%",
                  fontFamily: "Arial",
                  margin: "3rem 0 0 0",
                  borderRadius: "25px",
                }}
                id="rich-text"
                readOnly={!openRichTextP}
                value={richTextP}
                onChange={(rtext) => {
                  setRichTextP(rtext);
                  setValue("programs", rtext.toString("html"));
                  setRichTextPrograms(rtext.toString("html"));
                }}
              />

              <FormHelperText
                id="my-helper-text"
                error={Boolean(errors.programs)}
                helperText={errors.programs ? errors.programs.message : " "}
              />
              <Button
                fullWidth
                component="label"
                color="primary"
                variant="outlined"
                style={{ borderRadius: 25 }}
                onClick={() => {
                  setOpenRichTextP(!openRichTextP);
                }}
                disabled={!isAvailableToCreate}
              >
                {openRichTextP ? "Cerrar Editor" : "Agregar Programas"}
              </Button>
            </FormControl>
          </Grid>
          <Grid item lg={6} xs={12} sm={12}>
            <Button
              fullWidth
              component="label"
              color="primary"
              variant="outlined"
              style={{ borderRadius: 25 }}
              disabled={!isAvailableToCreate}
            >
              Agregar Logo
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleChange}
              />
            </Button>
          </Grid>
          <Grid item lg={6} xs={12} sm={12}>
            <Button
              fullWidth
              component="label"
              color="primary"
              variant="outlined"
              style={{ borderRadius: 25 }}
              disabled={!isAvailableToCreate}
            >
              Agregar Estudios Clinicos
              <input
                type="file"
                accept="application/pdf,application/vnd.ms-excel"
                multiple
                hidden
                onChange={handleChangeStudies}
              />
            </Button>
          </Grid>
          {previewImage && (
            <Grid item lg={12} xs={12} sm={12} style={{ textAlign: "center" }}>
              <img
                alt=""
                src={previewImage}
                style={{ objectFit: "cover", width: "100%" }}
              />
            </Grid>
          )}
          {previewDoc.map((doc, index) => (
            <Grid
              item
              lg={12}
              xs={12}
              sm={12}
              style={{ textAlign: "center", position: "relative" }}
              key={index}
            >
              <IconButton
                title="Eliminar"
                aria-label="Eliminar"
                className={classes.closeButton}
                onClick={() => onDeleteClinicalStudy(doc.name)}
              >
                <CloseIcon />
              </IconButton>
              <InsertDriveFileIcon
                fontSize="large"
                style={{ color: "#2196C0" }}
              />
              <Typography>{doc.name}</Typography>
            </Grid>
          ))}
          {/*<Grid item lg={12} xs={12} md={12}>
                            <MUIRichTextEditor
                                label="Type something here..."
                                onSave={save}
                                inlineToolbar={true}
                                placeho
                            />
                        </Grid>*/}

          {/* <Grid item xs={12} sm={12}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={4}
                                id="description"
                                label="Descripción"
                                name="description"
                                autoComplete="description"
                                size="small"
                                inputRef={register({
                                    required: "Descripción requerida"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.description ? true : false}
                                helperText={errors.description ? errors.description.message : ""}
                            />
                        </Grid> */}
        </Grid>
        <Button
          type="submit"
          fullWidth
          size="small"
          variant="contained"
          color="primary"
          className={classes.submit}
          disabled={loading}
          style={{ textTransform: "capitalize", borderRadius: "20px" }}
        >
          {!loading ? "Guardar" : "Cargando"}
        </Button>
      </form>
    </ModalBase>
  );
}

const useStyles = makeStyles((theme) => ({
  form: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  textField: {
    width: "100%",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: "#FFF",
    backgroundColor: theme.palette.secondary.main,
    width: 30,
    height: 30,
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  dialogTitle: {
    textAlign: "left",
    color: theme.palette.primary.main,
    "& h2": {
      fontWeight: "bold",
    },
  },
  formControl: {
    width: "100%",
    minWidth: 120,
  },
  select: {
    borderRadius: 25,
    color: theme.palette.primary.main,

    "& > div:nth-child(1)": {
      padding: "11px 14px",
      "&:focus": {
        borderRadius: "inherit",
      },
    },
    "&.Mui-disabled": {
      color: "#999ba7 !important",
    },
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  shrinkLabel: {
    "& .MuiInputLabel-outlined": {
      transform: "translate(18px, 12px) scale(0.8)",
      color: theme.palette.primary.main,
      "&.Mui-disabled": { color: "#999ba7 !important" },
      "&.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(0.75)",
        background: "#fff",
        padding: "0 5px",
      },
    },
    "& > div:nth-child(2)": {
      "& > fieldset": {
        "& > legend": {
          // maxWidth: 1000,
        },
      },
    },
  },
  autoComplete: {
    // background:'red'
    // "& .MuiFormLabel-root": {
    //   fontSize: "0.8rem",
    //   transform:'translate(14px, 18px) scale(1)',
    //   color: theme.palette.primary.main,
    //   "&.MuiInputLabel-shrink": {
    //     transform: "translate(14px, -6px) ",
    //     background: "#fff",
    //     padding: "0 5px",
    //   },
    // },
    "& .MuiInputBase-root": {
      padding: "4px 14px",
    },
    "& div": {
      borderRadius: 25,
    },
  },
  loadingIcon: {
    animation: "$spin 2s linear infinite",
  },
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
}));
